import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Typography Field Icons
// =============================================================================

export function FontFamily(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "FontFamily",
    viewBox: "0 0 24 24",
    path: (
      <>
        <polyline
          points="4 7 4 4 20 4 20 7"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="9"
          y1="20"
          x2="15"
          y2="20"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="4"
          x2="12"
          y2="20"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
